import { clear_flash_msg } from './flash_msg'

export default (() => {
  const displayFlashMessages = function (data) {
    const container = document.querySelector('.js-flash-message')
    for (const [key, value] of Object.entries(data)) {
      if (['error', 'success', 'info', 'warning', 'alert'].includes(key)) {
        window.$odin.flash_msg(value, key, {
          disable_swal: container.dataset.disableSwal,
        })
      } else if (
        key === 'message_data' &&
        data.error_data &&
        data.error_data.error
      ) {
        window.$odin.flash_msg(value, 'error', {
          disable_swal: container.dataset.disableSwal,
        })
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    // example: <div class="js-flash-now" data-messages='{"success":"test"}'></div>
    if (document.querySelector('.js-flash-now')) {
      document.querySelectorAll('.js-flash-now').forEach((el) => {
        displayFlashMessages(JSON.parse(el.dataset.messages))
      })
      return false
    }
    document.addEventListener('odims:display-flash-messages', () => {
      // POST /api/flash.json
      // prevent browser cache
      const timestamp = new Date().getTime()
      fetch('/api/flash.json?t=' + timestamp, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        cache: 'no-store',
      })
        .then((res) => {
          if (!res.ok) return null
          return res.json().catch(() => null)
        })
        .then((data) => {
          if (!data || typeof data !== 'object') return
          displayFlashMessages(data)
        })
        .catch(() => {})
    })
    document.dispatchEvent(new CustomEvent('odims:display-flash-messages'))
  })

  // bfcache（上一頁／下一頁）還原時，瀏覽器會把離開前那一刻的整個 DOM 原封不動放回來，
  // 包含當時還開著的 swal，而且不會重跑 DOMContentLoaded、也不會重打 /api/flash.json。
  // 訊息其實早就在前一次載入被消費掉了（get_flash 讀一次就 discard），畫面上那張是過期快照，
  // 看起來就像訊息被快取住。這裡把它清掉。
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) clear_flash_msg()
  })
})()
